const DEFAULT_SUPABASE_URL = 'https://sqvcbqgznlkphaqnsowh.supabase.co';

const normalizeBaseUrl = (url) => (url || '').replace(/\/$/, '');

const supabaseUrl = normalizeBaseUrl(import.meta.env.VITE_SUPABASE_URL || DEFAULT_SUPABASE_URL);

export const SUPABASE_FUNCTIONS_URL = supabaseUrl ? `${supabaseUrl}/functions/v1` : '';
